import PostPreview, { type PostPreviewContent } from '@kontentino/kontentino-post-previews';
import { Monitor, Smartphone } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { PreviewVariant } from './types';

export interface PreviewSectionProps {
  content: PostPreviewContent;
  previewVariant: PreviewVariant;
  onPreviewVariantChange: (variant: PreviewVariant) => void;
  previewContainerRef: React.RefObject<HTMLDivElement | null>;
  isInline?: boolean;
}

export function PreviewSection({
  content,
  previewVariant,
  onPreviewVariantChange,
  previewContainerRef,
}: PreviewSectionProps) {
  return (
    <div className={`flex overflow-hidden h-full py-2 gap-2`}>
      {/* Preview Mode Toggle - Vertical on left */}
      <div className="flex-shrink-0">
        <Tabs value={previewVariant} onValueChange={(value) => onPreviewVariantChange(value as PreviewVariant)}>
          <TabsList className="flex flex-col h-auto w-auto bg-secondary shadow-sm">
            <TabsTrigger value="desktop" title="Desktop view" className="aspect-square px-2 py-2">
              <Monitor className="h-4 w-4" />
            </TabsTrigger>
            <TabsTrigger value="mobile" title="Mobile view" className="aspect-square px-2 py-2">
              <Smartphone className="h-4 w-4" />
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      {/* Preview Content */}
      <div className="overflow-y-auto flex-1 flex justify-center items-start">
        <div ref={previewContainerRef} className="flex-shrink-0 w-full max-w-md">
          <PostPreview
            content={content}
            variant={previewVariant}
            enableLightbox={false}
          />
        </div>
      </div>
    </div>
  );
}
